import { Box, Button, Divider, FormControl, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useState } from 'react';
import { CampaignContext } from '../../contexts/CampaignContext';
import usePlatformCardColors from '../../hooks/usePlatformCardColors';
import { getMediaLogo } from '../../utils/file';
import { ISmsPanel, ISmsPanelContent } from '../../interfaces/campaign';
import axios from 'axios';
import IResponse from '../../interfaces/response';

type PreviewSmsPanelProps = {
	smsContent: ISmsPanelContent | null;
	handleOpenPostModal: () => void;
};

type IJobsSelectBox = {
	id: number;
	title: string;
	is_active: boolean;
};

const PreviewSmsPanel: React.FC<PreviewSmsPanelProps> = ({ smsContent, handleOpenPostModal }) => {
	const { t } = useTranslation();
	const [jobs, setJobs] = useState<IJobsSelectBox[]>([]);
	const [age, setAge] = useState<IJobsSelectBox[]>([]);
	const [location, setLocation] = useState<ISmsPanel[] | null>(null);

	const { selectedContentType, selectedPlatform } = useContext(CampaignContext);
	const { borderColorClass } = usePlatformCardColors(selectedPlatform!);

	useEffect(() => {
		axios<IResponse<ISmsPanel[]>>({
			method: 'get',
			url: '/locations',
		}).then(async res => {
			if (res.data.success) {
				setLocation(res.data.data);
			}
		});
		axios<IResponse<IJobsSelectBox[]>>({
			method: 'get',
			url: '/options/job',
		}).then(async res => {
			if (res.data.success) {
				setJobs(res.data.data);
			}
		});
		axios<IResponse<IJobsSelectBox[]>>({
			method: 'get',
			url: '/options/campaign_age',
		}).then(async res => {
			if (res.data.success) {
				setAge(res.data.data);
			}
		});
	}, []);

	let provinceFilter = location?.find(item => item.id == smsContent?.province_id);
	let ageFilter = age?.find(item => item.id === smsContent?.age_id);
	let jobFilter = jobs?.find(item => item.id === smsContent?.job_id);

	return (
		<>
			<Box className="relative flex gap-x-6 pt-10">
				<Box className={`flex w-full gap-5`}>
					<div className="flex flex-wrap gap-4">
						<Box className="w-[350px]">
							<Box className={`relative rounded-2xl border ${borderColorClass}`}>
								<Box className="flex items-center justify-between px-3 py-2">
									<Typography className="text-base font-medium text-grey-900">{selectedContentType ? t(selectedContentType) : t('post')}</Typography>
									<Divider className={`mx-2 grow border ${borderColorClass}`} />
									<img src={getMediaLogo(selectedPlatform!)} alt={`${t(selectedPlatform!)} logo`} className="mb-1 h-8 w-8" />
								</Box>
								<Divider className={`border-1 ${borderColorClass}`} />
								<div className="relative">
									<Box className="rounded-b-2xl bg-blue-50 p-7">
										<Typography className="" sx={{ wordBreak: 'break-word' }}>
											<Box className="relative rounded-xl p-4" sx={{ backgroundColor: '#D9D9D9' }}>
												{smsContent?.text}
												<img className="absolute -left-1.5 bottom-0" src="/images/campaigns/poligon.svg" alt="" />
											</Box>
										</Typography>
									</Box>
								</div>
								<img className="" src="/images/campaigns/panelBottomBar.png" alt="" />
							</Box>
						</Box>
					</div>
					<Button variant="text" className="absolute left-5 top-0 m-0 flex self-end px-0" onClick={handleOpenPostModal}>
						{t('edit')}
					</Button>

					<Box className="w-full">
						<TextField
							InputProps={{
								readOnly: true,
							}}
							fullWidth
							label={t('text_message')}
							variant="outlined"
							multiline
							rows={5}
							value={smsContent?.text}
						/>
						<div className="mt-5 flex flex-wrap justify-between">
							<FormControl className="my-4 w-[48%]">
								<TextField
									InputProps={{
										readOnly: true,
									}}
									size="medium"
									label={t('province')}
									variant="outlined"
									value={provinceFilter?.title}
								/>
							</FormControl>
							<FormControl className="my-4 w-[48%]">
								<TextField
									InputProps={{
										readOnly: true,
									}}
									size="medium"
									label={t('gender')}
									variant="outlined"
									value={smsContent?.gender}
								/>
							</FormControl>
							<FormControl className="my-4 w-[48%]">
								<TextField
									InputProps={{
										readOnly: true,
									}}
									size="medium"
									label={t('jobs')}
									variant="outlined"
									value={jobFilter?.title}
								/>
							</FormControl>
							<FormControl className="my-4 w-[48%]">
								<TextField
									InputProps={{
										readOnly: true,
									}}
									size="medium"
									label={t('oprator')}
									variant="outlined"
									value={smsContent?.operator}
								/>
							</FormControl>
							<FormControl className="my-4 w-[48%]">
								<TextField
									InputProps={{
										readOnly: true,
									}}
									size="medium"
									label={t('age')}
									variant="outlined"
									value={ageFilter?.title}
								/>
							</FormControl>
						</div>
					</Box>
				</Box>
			</Box>
		</>
	);
};

export default PreviewSmsPanel;
